/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateSiteSectionDocumentResponseData,
  CreateSiteSectionDocumentResponseDataFromJSON,
  CreateSiteSectionDocumentResponseDataFromJSONTyped,
  CreateSiteSectionDocumentResponseDataToJSON
} from './CreateSiteSectionDocumentResponseData'

/**
 *
 * @export
 * @interface CreateSiteSectionDocumentResponse
 */
export interface CreateSiteSectionDocumentResponse {
  /**
   *
   * @type {number}
   * @memberof CreateSiteSectionDocumentResponse
   */
  status?: number
  /**
   *
   * @type {CreateSiteSectionDocumentResponseData}
   * @memberof CreateSiteSectionDocumentResponse
   */
  data?: CreateSiteSectionDocumentResponseData
}

export function CreateSiteSectionDocumentResponseFromJSON(json: any): CreateSiteSectionDocumentResponse {
  return CreateSiteSectionDocumentResponseFromJSONTyped(json, false)
}

export function CreateSiteSectionDocumentResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateSiteSectionDocumentResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CreateSiteSectionDocumentResponseDataFromJSON(json['data'])
  }
}

export function CreateSiteSectionDocumentResponseToJSON(value?: CreateSiteSectionDocumentResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CreateSiteSectionDocumentResponseDataToJSON(value.data)
  }
}
